import { CkEditorCustom } from "src/app/components";
import { useField } from "formik";
import { Container, Row } from "react-bootstrap";

export interface IUpsertSiteFormPersonaBody {}

export const UpsertSiteFormPersonaBody: React.FC<IUpsertSiteFormPersonaBody> = () => {
    const [, personaMetaProps, personaHelperProps] = useField("persona");

    return (
        <Container>
            <Row>
                <CkEditorCustom
                    data={personaMetaProps.value}
                    onChange={(event, editor) => {
                        personaHelperProps.setValue(editor.getData());
                    }}
                />
            </Row>
        </Container>
    );
};

export default UpsertSiteFormPersonaBody;
